import { render, staticRenderFns } from "./modal_file_vetus.vue?vue&type=template&id=bd3dc65e&scoped=true"
import script from "./modal_file_vetus.vue?vue&type=script&lang=js"
export * from "./modal_file_vetus.vue?vue&type=script&lang=js"
import style0 from "./modal_file_vetus.vue?vue&type=style&index=0&id=bd3dc65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3dc65e",
  null
  
)

export default component.exports